import { Button, Col, Row, Input } from "antd";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CustomFormItem from "../../components/CustomFormItem/CustomFormItem";
import LabelWithDropDown from "../../components/LabelWithDropDown/LabelWithDropDown";
import { useLanguage } from "../../hooks";
import {
  LANGUAGE_CODES,
  FORM_FIELDS_LOOKUP,
  HELPER_TEXT_KEYS,
  BUILDING_TABS_KEYS,
  BUILDING_REQUIRED_FIELDS_LOOKUP,
  FORM_FIELDS_TYPE,
} from "../../utils/constants";
import { validateMarketingDescription } from "../../utils/utils";
import AppModal from "../../components/AppModal/AppModal";

const BuildingMarketingDescription = ({
  viewOnlyMode,
  tooltip,
  label,
  templateName,
  form,
  templateList,
  parentId,
  tab,
  fieldName,
  auditPanelDrawerVisible,
  ...props
}) => {
  const { t } = useTranslation();
  const [templateId, setTemplateId] = useState(null);
  const { language, languageStatus } = useLanguage();
  const { lookupList } = useSelector(state => state.helperText);
  const [modalVisible, setModalVisibility] = useState(false);
  const fieldsType = FORM_FIELDS_TYPE.regular;

  const populateDescription = data => {
    if (data) {
      const country = form.getFieldValue(["buildingInfo", "address", "country"]);
      const selectedTemplate = templateList.find(item => item.id === data);
      const marketingDescription = _get(
        selectedTemplate,
        `translations.${
          country === "Mexico" && language.current !== LANGUAGE_CODES.English.value
            ? LANGUAGE_CODES.Mexico.value
            : language.current
        }.template`,
        selectedTemplate?.template,
      );
      const obj = {};
      if (languageStatus !== "primary") {
        obj.translations = {
          [language.current]: { descriptionTab: { marketingDescription } },
        };
      } else {
        obj.descriptionTab = { marketingDescription };
      }
      form.setFieldsValue({ ...obj });
      setTemplateId(data);
    }
  };

  const setTemplateDescription = data => {
    if (!_isEmpty(data)) {
      if (_isEmpty(form.getFieldValue("descriptionTab")?.marketingDescription)) {
        populateDescription(data);
      } else {
        setModalVisibility(true);
      }
    }
  };

  const _onCancel = () => {
    setModalVisibility(false);
    form.setFieldsValue({ buildingInfo: { templateId } });
  };

  const _onConfirm = () => {
    console.log("form data :", form);
    populateDescription(form.getFieldValue(["buildingInfo", "templateId"]));
    setModalVisibility(false);
  };

  return (
    <>
      <Col span={8} xs={24} sm={8} lg={8}>
        <CustomFormItem
          className="form-item-label-with-drop-down"
          label={
            <LabelWithDropDown
              label={t("Property.MarketingDescription")}
              tooltip={lookupList[HELPER_TEXT_KEYS.building.marketingDescription]}
              templateId={templateId}
              changeHandler={setTemplateDescription}
              options={templateList}
              viewOnlyMode={viewOnlyMode}
              name={["buildingInfo", "templateId"]}
              form={form}
              tab={BUILDING_TABS_KEYS[7]}
              fieldName={FORM_FIELDS_LOOKUP.building.buildingInfo.marketingDescription.key}
              auditPanelDrawerVisible={auditPanelDrawerVisible}
            />
          }
          name={["descriptionTab", "marketingDescription"]}
          rules={[
            {
              required: BUILDING_REQUIRED_FIELDS_LOOKUP[fieldsType].descriptionTab.marketingDescription,
              message: t("BuildingInfo.MarketingDescriptionRulesMessage"),
            },
            { whitespace: true, message: t("BuildingInfo.MarketingDescriptionWhitespaceMessage") },
            {
              validator: (rule, value) => validateMarketingDescription(value, t("Property.MarketingDescription")),
            },
          ]}
        >
          <Input.TextArea placeholder={t("Property.MarketingDescription")} row={5} disabled={viewOnlyMode} />
        </CustomFormItem>
      </Col>
      <AppModal
        centered
        wrapClassName="modal-associated-properties"
        title={t("Template.Confirmation")}
        width={600}
        minHeight="10vh"
        maxHeight="60vh"
        overFlowY="auto"
        visible={modalVisible}
        onCancel={_onCancel}
        footer={
          <Row justify="center" gutter={24}>
            <Col xs={12} sm={12} md={8} lg={8}>
              <Button block onClick={_onCancel}>
                {t("Buttons.Cancel")}
              </Button>
            </Col>
            <Col xs={12} sm={12} md={8} lg={8}>
              <Button block type="primary" onClick={_onConfirm}>
                {t("Buttons.Confirm")}
              </Button>
            </Col>
          </Row>
        }
        destroyOnClose
      >
        <p>{t("Template.ConfirmationMessage")}</p>
      </AppModal>
    </>
  );
};

BuildingMarketingDescription.propTypes = {
  viewOnlyMode: PropTypes.bool,
  tooltip: PropTypes.object,
  label: PropTypes.string,
  parentId: PropTypes.string,
  templateName: PropTypes.array,
  name: PropTypes.array,
  templateList: PropTypes.array,
  form: PropTypes.object,
  tab: PropTypes.string,
  fieldName: PropTypes.string,
  auditPanelDrawerVisible: PropTypes.bool,
};
export default BuildingMarketingDescription;
